const upsertMeta = (attr, key, content) => {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export function setMeta({ title, description, image, path, noindex = false }) {
  if (title) document.title = title;
  const url = `${window.location.origin}${path || window.location.pathname}`;
  upsertMeta("name", "description", description);
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:url", url);
  upsertMeta("property", "og:type", "website");
  if (image) {
    const abs = image.startsWith("http") ? image : `${window.location.origin}${image}`;
    upsertMeta("property", "og:image", abs);
    upsertMeta("name", "twitter:image", abs);
  }
  upsertMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
  upsertMeta("name", "twitter:title", title);
  upsertMeta("name", "twitter:description", description);
  upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}
